import React, { Component } from 'react'
import Col from 'reactstrap/lib/Col'
import Row from 'reactstrap/lib/Row'
import styled from 'styled-components'
import WidgetContainer from '../containers/WidgetContainer'
import LinkHandler from '../utils/LinkHandler'
import Link from '../utils/Link'
import SpirmonLink from '../utils/SpirmonLink'
import { SERVICES_LINKS, SIZES } from '../../constants'
import { sendWidgetClick } from '../utils/ga4Events'

const LinkBox = styled(Link)`
  color: ${props => props.theme.services.color};
  display: inline-block;
  padding: 5px 0;

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-right: 13px;
  }
`

const SpirmonLinkBox = LinkBox.withComponent(SpirmonLink)

const LinkCol = styled(Col)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  -ms-flex-direction: row;
  justify-content: space-between;
  margin-top: -10px;
  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    justify-content: flex-start;
    -ms-flex-pack: start;
  }
`

export default class Services extends Component {
  renderLinks () {
    const {
      widget,
      widget: {
        utmMedium,
        utmSource,
        utmContent,
        meta: {
          admon
        }
      }
    } = this.props

    return SERVICES_LINKS.map(link => {
      const utmParams = {
        utmSource,
        utmMedium,
        utmContent
      }
      const location = link.redirectPattern
        ? new LinkHandler(link.location).mergeUTMParams(utmParams).applySASRedirect(admon).link
        : new LinkHandler(link.location).mergeUTMParams(utmParams).link

      return (
        link.redirectPattern
          ? <SpirmonLinkBox href={location} key={link.text} widget={widget}>{link.text}</SpirmonLinkBox>
          : <LinkBox onClick={this.handleLinkClick(link.text)} href={location} key={link.text}>{link.text}</LinkBox>
      )
    })
  }

  handleLinkClick = serviceName => () =>
    sendWidgetClick({
      name: this.props.widget.name,
      click: {
        type: 'link',
        label: serviceName
      }
    })

  render () {
    const {
      widget,
      googleAnalytics
    } = this.props

    return (
      <WidgetContainer googleAnalytics={googleAnalytics} widget={widget}>
        <Row>
          <LinkCol>
            {this.renderLinks()}
          </LinkCol>
        </Row>
      </WidgetContainer>
    )
  }
}
